export enum KompetenceListViewTypeEnum {
    Standard = 1,
    Planlagt = 2,
}
